<div class="custom-tree-camp">
    <ng-container *ngFor="let node of dataSource;">

        <!-- GROUP WRAPPER -->
        <div class="custom-tree-group" [class.cm-menu-open]="node.expandable">

            <!-- PARENT -->
            <div class="custom-tree-parent" tabindex="0" role="button" (keydown.enter)="companyManagement(node)" (keyup.space)="companyManagement(node)" (click)="companyManagement(node)">
                <div class="custom-tree-heading">{{ node.name }}</div>
                <button aria-label="Expand menu" mat-icon-button>
                    <mat-icon fontSet="material-symbols-outlined" aria-hidden="true" class="mat-icon-rtl-mirror">
                        {{ node.expandable ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                    </mat-icon>
                </button>
            </div>

            <!-- CHILD WRAPPER -->
            <div class="custom-tree-child-wrapper" *ngIf="node.expandable">
                <ng-container *ngFor="let child of node?.children">
                    <button type="button" class="button-as-div custom-tree-child" [routerLink]="child.navigate" routerLinkActive="active"
                        (click)="onChildClick($event,child)">
                        <div class="custom-tree-heading">{{ child.name }}</div>
                </button>
                </ng-container>
            </div>

        </div>
        <!-- END GROUP -->
    </ng-container>
</div>